import { render, staticRenderFns } from "./MasterClass.vue?vue&type=template&id=61a95479"
import script from "./MasterClass.vue?vue&type=script&lang=js"
export * from "./MasterClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports